import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Interaction } from '@principle-theorem/principle-core';
import {
  isInteractionV2,
  type IInteraction,
  type IInteractionV2,
  type ILabJob,
  type IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, snapshot, type WithRef } from '@principle-theorem/shared';
import { type Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-lab-job-interactions',
  templateUrl: './lab-job-interactions.component.html',
  styleUrls: ['./lab-job-interactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabJobInteractionsComponent {
  labJob$: ReplaySubject<WithRef<ILabJob>> = new ReplaySubject(1);
  practice$ = new ReplaySubject<WithRef<IPractice>>(1);
  pinnedInteractions$: Observable<(IInteractionV2 | IInteraction)[]> =
    this.labJob$.pipe(
      map((labJob) => Interaction.getPinnedInteractions(labJob.interactions))
    );
  @Output() cancelled = new EventEmitter<void>();

  @Input()
  set practice(practice: WithRef<IPractice>) {
    if (practice) {
      this.practice$.next(practice);
    }
  }

  @Input()
  set labJob(labJob: WithRef<ILabJob>) {
    if (labJob) {
      this.labJob$.next(labJob);
    }
  }

  async addInteraction(interaction: IInteractionV2): Promise<void> {
    const labJob = await snapshot(this.labJob$);
    await Firestore.patchDoc(labJob.ref, {
      interactions: [...labJob.interactions, interaction],
    });
  }

  async updateInteraction(
    interaction: IInteraction | WithRef<IInteractionV2>
  ): Promise<void> {
    if (!isInteractionV2(interaction)) {
      return;
    }
    const labJob = await snapshot(this.labJob$);
    const interactions = labJob.interactions.map((item) =>
      item.uid === interaction.uid ? interaction : item
    );
    await Firestore.patchDoc(labJob.ref, { interactions });
  }
}
